exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*table {\r\n    width: 100%;\r\n    height: 100%;\r\n    text-align: center;\r\n}\r\n\r\ntable td {\r\n    position: relative;\r\n    height: 100%;\r\n}\r\n\r\ntable td:first-child {\r\n    width: 20%;\r\n    min-width: 300px;\r\n}\r\n\r\ntable td:last-child {\r\n    width: 80%;\r\n}\r\n\r\n\r\n\r\n.section {\r\n    width: 85%;\r\n    height: 100%;\r\n    margin: 0px auto;\r\n}\r\n*/", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/_Components/app-navigate/app-navigate.component.css
// module id = 330
// module chunks = 1